import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as SelectionActions from '../../actions/Selection.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Helpers from '../../helpers';

const styles = {
  wrapper: {
    width: '100%',
    maxWidth: 720,
    height: 356,
    margin: '24px auto',
    backgroundColor: '#fff',
    padding: '10px 24px',
  },
  wrapper_TV: {
    width: '90%',
    height: 700,
    margin: '24px auto',
    backgroundColor: '#fff',
    padding: '10px 24px',
  },
  image: {
    display: 'block',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    width: '100%',
    maxHeight: 260,
    height: '100%',
  },
  image_TV: {
    display: 'block',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    width: '100%',
    height: '85%',
  },
  bar: {
    width: 'calc(100% - 48px)',
    height: 48,
    margin: '18px 24px 0 24px',
    padding: '21px 0',
    position: 'relative',
  },
  barBackground: {
    backgroundColor: '#9b9b9b',
    borderRadius: 3,
    width: '100%',
    display: 'block',
    height: 6,
    opacity: 0.4,
  },
  pan: {
    position: 'absolute',
    top: 0,
    left: -24,
    borderRadius: 24,
    height: 48,
    width: 48,
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: '#fff',
    cursor: 'pointer',
  },
};

class SelectionPreviewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageIndex: 0,
      panStartX: null,
    };
  }

  componentWillMount() {
    const {
      firmId,
      typeId,
      characterId,
      colorId,
      fetchSelectionPhotos,
    } = this.props;

    if (firmId && typeId && characterId && colorId) fetchSelectionPhotos(typeId, characterId, colorId, firmId);
  }

  componentWillReceiveProps(nextProps) {
    const {
      firmId,
      typeId,
      characterId,
      colorId,
      fetchSelectionPhotos,
    } = nextProps;

    if (firmId !== this.props.firmId
      || typeId !== this.props.typeId
      || characterId !== this.props.characterId
      || colorId !== this.props.colorId) {
      if (firmId && typeId && characterId && colorId) fetchSelectionPhotos(typeId, characterId, colorId, firmId);
    }

    // Preload images
    if (nextProps.images !== this.props.images) {
      nextProps.images.forEach(image => {
        const img = new Image();
        img.src = image.url;
      });
    }
  }

  panStart(x) {
    this.setState({
      panStartX: x,
    });
  }

  panning(x) {
    const {
      bar,
      pan,
    } = this.refs;

    const {
      panStartX,
      imageIndex,
    } = this.state;

    const {
      images,
    } = this.props;

    if (!panStartX) return;

    const zeroX = bar.offsetLeft + 24;
    const stepWidth = bar.offsetWidth / images.length;
    const deltaX = Math.min(Math.max(x - zeroX, -24), bar.offsetWidth - 24);
    const displayImageIndex = Math.max(Math.floor(deltaX / stepWidth), 0);

    pan.style.left = `${deltaX}px`;

    if (imageIndex !== displayImageIndex) {
      this.setState({
        imageIndex: displayImageIndex,
      });
    }
  }

  panEnd() {
    const {
      bar,
      pan,
    } = this.refs;

    const {
      imageIndex,
    } = this.state;

    const {
      images,
    } = this.props;

    const stepWidth = bar.offsetWidth / images.length;

    pan.style.left = `${stepWidth * imageIndex}px`;

    this.setState({
      panStartX: null,
    });
  }

  render() {
    const {
      imageIndex,
    } = this.state;

    const {
      images,
    } = this.props;

    var wrapper = styles.wrapper;
    var image = styles.image;

    if (Helpers.Session.isViaTV()) {
      wrapper = styles.wrapper_TV;
      image = styles.image_TV;
    }

    return (
      <div style={wrapper}>
        <div
          style={[
            image,
            images[imageIndex] && {
              backgroundImage: `url(${images[imageIndex].url})`,
            },
          ]} />
        <div
          ref="bar"
          style={styles.bar}
          onTouchEnd={() => this.panEnd()}
          onMouseUp={() => this.panEnd()}
          onTouchMove={e => this.panning(e.changedTouches[0].clientX)}
          onMouseMove={e => this.panning(e.clientX)}>
          <span style={styles.barBackground} />
          <span
            ref="pan"
            style={styles.pan}
            onTouchStart={e => this.panStart(e.changedTouches[0].clientX)}
            onMouseDown={e => this.panStart(e.clientX)} />
        </div>
      </div>
    );
  }
}

SelectionPreviewer.propTypes = {
  firmId: T.number,
  characterId: T.number,
  typeId: T.number,
  colorId: T.number,
  images: T.array,
  fetchSelectionPhotos: T.func,
};

export default connect(
  state => ({
    images: state.Selection.images,
  }),
  dispatch => bindActionCreators(SelectionActions, dispatch),
)(radium(SelectionPreviewer));



// WEBPACK FOOTER //
// ./containers/Selections/SelectionPreviewer.js